import axios from "axios";
import { environment } from "../../environment";
import { User } from "hc-entities";
import { clean, toFormData } from "../helpers/helpers";

const BASE_URL = environment.authUrl;

export const UsersService = () => {
  const invite = async (uid: string): Promise<any> => {
    try {
      const path = `${environment.authUrl}mailer/reinvite`;
      const res = await axios.put(path, { uid });
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  const resetpassword = async (uid: string): Promise<any> => {
    try {
      const path = `${environment.authUrl}mailer/resetpassword`;
      const res = await axios.put(path, { uid });
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  const sendReminderForNonTaskCompleters = async (ids: string[], taskId: string, taskTitle: string, eventTitle: string): Promise<any> => {
    try {
      const path = environment.authUrl + "sf/send-task-reminder";
      const body = { ids: ids, taskId: taskId, taskTitle: taskTitle, eventTitle: eventTitle };
      const res = await axios.post(path, body);
      return res?.data || res;
    } catch (err) {
      throw err;
    }
  };

  const sendEmailNotification = async (ids: [], post: string, subject: string, language: string): Promise<any> => {
    try {
      const path = environment.authUrl + "mailer/send-notification";
      const body = { ids: ids, post: post, subject: subject, language: language };
      const res = await axios.post(path, body);
      return res?.data || res;
    } catch (err) {
      console.log("err:", err);
      throw err;
    }
  };


  const sendMobileNotification = async (deviceTokens: [], msgObj: any): Promise<any> => {
    try {
      const path = `${BASE_URL}mailer/send-mobile-notification`;
      const body = { deviceTokens: deviceTokens, msgObj: msgObj };
      const res = await axios.post(path, body);
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  const me = async () => {
    try {
      const path = environment.authUrl + 'me';
      const res: any = await axios.get(path);
      if (res?.data)
        return res.data;
      else throw new Error('No user found')
    } catch (err) {
      throw err;
    }
  }

  const getUsersBySessionId = async (id: string): Promise<User[]> => {
    try {
      const url = `${environment.contentUrl}user/classes/${id}`;
      const response = await axios.get<any>(url);

      return Array.isArray(response?.data)
        ? response.data.map(user => new User(user))
        : [];
    } catch (err) {
      throw err;
    }
  };


  const getUsersByCommunityId = async (id: string): Promise<User[]> => {
    try {
      const path = `${environment.authUrl}community/${id}`;
      const res = await axios.get(path);
      const users: User[] = [];
      if (res?.data && res?.data?.length > 0) {
        res.data.map((u: any) => {
          users.push(new User({ ...u }));
          return u;
        });
      }
      return [];
    } catch (err) {
      throw err;
    }
  };

  const getUserById = async (id: string): Promise<User[]> => {
    try {
      const path = `${environment.authUrl}user/${id}`;
      return await axios.get(path);
    } catch (err) {
      throw err;
    }
  };

  const getAll = async (): Promise<User[]> => {
    try {
      const path = `${environment.authUrl}list`;
      const res = await axios.get(path);
      const users: User[] = [];
      if (res?.data && res?.data?.length > 0) {
        res.data.map((u: any) => {
          users.push(
            new User({
              ...u,
              statusChanged: u.statusChanged
                ? new Date(parseInt(u.statusChanged))
                : undefined,
              registered: u.registered
                ? new Date(parseInt(u.registered))
                : undefined,
            })
          );
          return u;
        });
      }
      return users;
    } catch (err) {
      throw err;
    }
  };

  const getLengthOfUsersDB = async (): Promise<User[]> => {
    try {
      const path = `${environment.authUrl}user/length`;
      return await axios.get(path);
    } catch (err) {
      throw err;
    }
  };

  const filterUsersForUserModule = async (param: string): Promise<User[]> => {
    try {
      const path = `${environment.authUrl}user/filter/${param}`;
      const res = await axios.get(path);
      const users: User[] = [];
      if (res?.data && res?.data?.length > 0) {
        res.data.map((u: any) => {
          users.push(new User({ ...u }));
          return u;
        });
      }
      return users;
    } catch (err) {
      throw err;
    }
  };

  const paginateUsersForUserModule = async (skip: number, limit: number): Promise<User[]> => {
    try {
      const path = `${environment.authUrl}user/paginate/${skip}/${limit}`;
      const res = await axios.get(path);
      const users: User[] = [];
      if (res?.data && res?.data?.length > 0) {
        res.data.map((u: any) => {
          users.push(new User({ ...u }));
          return u;
        });
      }
      return users;
    } catch (err) {
      throw err;
    }
  };

  const filterUserListByNameOrEmail = async (param: string): Promise<User[]> => {
    try {
      const url = `${environment.authUrl}user/filterUserListByNameOrEmail/${param}`;
      const response = await axios.get(url);
      const users: User[] = response?.data?.map((userData: any) => new User({ ...userData })) || [];
      return users;
    } catch (error) {
      throw error;
    }
  };

  const registerUserToEntity = async (userid: string, entity: string, entityType: string, role: string) => {
    try {
      const data = {
        userid: userid,
        entity: entity,
        entityType: entityType,
        role: role
      }
      const path = `${environment.authUrl}user/register`;
      const res = await axios.post(path, data);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const updateFaculty = async (newFaculty: any[], initialFaculty: any[], entityId: string) => {
    let teamResults: any = [];
    for (const newUser of newFaculty) {
      const isUserAlreadyRegistered = initialFaculty.some(
        (initialUser) => initialUser.Name__r.HN_UserId__c === newUser.id
      );
      
      if (isUserAlreadyRegistered && !newUser.checked) {
        const result = await unRegisterUserFromEntity(newUser.id, entityId, "class", "teamMember");
        teamResults.push(result.data);
      } else if (!isUserAlreadyRegistered && newUser.checked) {
        const result = await registerUserToEntity(newUser.id, entityId, "class", "teamMember");
        teamResults.push(result);
      }
    }
    return teamResults;
  };

  const getUserByArrayOfIds = async (users: []) => {
    try {
      const path = `${environment.authUrl}user/arrayOfIds`;
      const res = await axios.post(path, users);
      return res.data;
    } catch (err) {
      throw err;
    }
  };



  const unRegisterUserFromEntity = async (userid: string, entity: string, entityType: string, role?: "participant" | "teamMember") => {
    try {
      const data = {
        userid,
        entity,
        entityType,
        role,
      };
      const path = `${environment.authUrl}user/unregister`;
      const res = await axios.post(path, data);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const notifyUser = async (userId: string, entity: string) => {
    try {
      const path = `${environment.authUrl}user/notify`;
      const res = await axios.post(path, { userId, entity });
      return res;
    } catch (err) {
      throw err;
    }
  };


  const update = async (user: User) => {
    try {
      const path = `${environment.authUrl}user/update`;
      const res = await axios.post(path, user);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const deleteUser = async (userid: string) => {
    try {
      const path = `${environment.authUrl}user/delete`;
      const config = {
        data: {
          id: userid
        }
      }
      const res = await axios.delete(path, config);
      return res;
    } catch (err) {
      throw err;
    }
  };


  const edit = async (user: any) => {
    try {
      const path = environment.authUrl + 'client/user/update';
      const cleanUser = clean(user);
      const formData = toFormData(cleanUser);
      const res: any = await axios.put(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      });
      return res;
    } catch (err) {
      throw err
    }
  }
  
  const syncSeminars = async (): Promise<any> => {
    try {
      const path = `${BASE_URL}sync/seminars`;      
      const res = await axios.get(path);
      return res;
    } catch (err) {
      console.error("Error syncing seminars:", err);
      throw err;
    }
  };

  const previewSyncSeminars = async (): Promise<any> => {
    try {
      const path = `${BASE_URL}sync/seminars/preview`;
      const res = await axios.get(path);
      return res.data;
    } catch (err) {
      console.error("Error previewing seminars sync:", err);
      throw err;
    }
  };

  const empty = async (collection: string) => {
    try {
      const path = environment.contentUrl + `${collection}`;
      const res = await axios.delete(path);
      return res;
    } catch (err) {
      throw err;
    }
  };

  return {
    invite,
    getUserByArrayOfIds,
    resetpassword,
    registerUserToEntity,
    updateFaculty,
    getUserById,
    getLengthOfUsersDB,
    unRegisterUserFromEntity,
    filterUsersForUserModule,
    paginateUsersForUserModule,
    filterUserListByNameOrEmail,
    sendReminderForNonTaskCompleters,
    sendEmailNotification,
    sendMobileNotification,
    deleteUser,
    getAll,
    getUsersByCommunityId,
    getUsersBySessionId,
    update,
    syncSeminars,
    previewSyncSeminars,
    empty,
    me,
    edit,
    notifyUser
  };
};
